import { DeleteRounded, DragIndicator } from "@mui/icons-material";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	ListItem,
	ListItemIcon,
	ListItemText,
	MenuItem,
	Select,
	Stack,
	Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { GlobalState } from "context/GlobalContext";
import { converAttrToDatagridCol, inputTypes, arrType, selectOptionsKeyName, constraints, datatypes } from "data/globalData";
import { useEffect, useState } from "react";
import { Reorder } from "framer-motion";
import { StudioDashboardState } from "context/StudioDashboardContext";
import { PimDashboardState } from "context/PimDashboardContext";
import RenderInputField from "components/PimDashboard/CommonComponents/RenderInputField/RenderInputField";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import FileSaver from "file-saver";
import axios from "axios";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";

const colStyle = {
	headerAlign: "center",
	align: "center",
};

const exportTypeColumn = {
	name: "File Type",
	key: "export_type",
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	constraints: { NOTNULL: true, DISPLAY: true },
	[selectOptionsKeyName]: {
		type: arrType,
		list: [
			{ key: "STANDARD", name: "Standard" },
			{ key: "GINESYS_FORMAT", name: "Ginesys Format" },
			{ key: "FULL_DUMP", name: "Full Dump" },
		],
	},
};

const DataExportModal = ({ modal, handleCloseModal, filterColumnVal }) => {
	const { snackBar, setSnackBar, setSnackBarOpen } = GlobalState();
	const { setLoadingOpen } = GlobalState();

	const defFileTypeObj = {
		[exportTypeColumn.key]: exportTypeColumn?.[selectOptionsKeyName]?.[0]?.key,
	};

	const [fileTypeState, setFileTypeState] = useState({ ...defFileTypeObj });

	const handleDownloadClick = async () => {
		try {
			let apiUrl = "";
			let fileName = "";
			let axiosInsatance = null;
			if (fileTypeState[exportTypeColumn.key] === "GINESYS_FORMAT") {
				apiUrl = "/api/download_styles_ginesys_format";
				fileName = "styles_ginesys_format.xlsx";
				axiosInsatance = pythonVmInstance;
			} else if (fileTypeState[exportTypeColumn.key] === "FULL_DUMP") {
				apiUrl = "/api/download_styles_dump";
				fileName = "all_styles_dump.xlsx";
				axiosInsatance = pythonVmInstance;
			} else if (fileTypeState[exportTypeColumn.key] === "STANDARD") {
				apiUrl = "/api/designer/download_styles";
				fileName = "styles.xlsx";
				axiosInsatance = axios;
			}
			setLoadingOpen(true);
			await axiosInsatance({
				url: apiUrl,
				method: "POST",
				responseType: "blob",
				data: { filter: filterColumnVal },
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `${fileName}_${new Date().toISOString()}.xlsx`);
				setLoadingOpen(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "File Downloaded Successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				handleCloseModal();
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	return (
		<Dialog fullWidth maxWidth="sm" open={modal} onClose={handleCloseModal} scroll="body">
			<Stack
				width="100%"
				p={2}
				boxSizing="border-box"
				spacing={1}
				// justifyContent="space-around"
			>
				<Typography variant="h6">Export Data</Typography>

				<RenderInputField
					column={exportTypeColumn}
					data={fileTypeState}
					setData={setFileTypeState}
					selectOptObjName={selectOptionsKeyName}
					width="100%"
				/>
			</Stack>
			<DialogActions>
				<Button variant="outlined" onClick={handleCloseModal}>
					Cancel
				</Button>
				<Button autoFocus variant="contained" sx={{ mr: 1 }} onClick={handleDownloadClick}>
					Download
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DataExportModal;
